import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

const styles = {
  containerFiles: {
    display: 'flex',
    borderRadius: '10px',
    backgroundColor: '#E4E6EB',
    margin: '10px',
    padding: '5px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mainContainer: {
    width: '100%',
    height: '100%',
  },
  cardContainer: {
    display: 'flex',
    padding: '10px',
    justifyContent: 'space-between',
  },
  image: {
    width: '150px',
    height: '150px',
    borderRadius: '75px',
    margin: '10px',
  },
  iconButtonImg: {
    position: 'absolute',
    top: '231px',
    left: '385px',
    border: '2px solid white',
    color: 'black',
    padding: '0',
    background: 'gainsboro',
    '&:hover': {
      background: 'gainsboro',
    },
    '&:disabled': {
      background: 'gainsboro',
      color: 'black',
    },
  },
  cardActions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  imageWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  likesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 10px 0 10px',
  },

  title: {
    fontSize: '20px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
  },
  testResult: {
    fontSize: '15px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
    color: 'gray',
  },
  reelContainer: {
    display: 'flex',
    marginTop: '20px',
    justifyContent: 'space-between',
  },
  leftContainer: {
    width: '40%',
    padding: '0 5px 0 0',
  },
  rightContainer: {
    width: '60%',
    padding: '0 0 0 5px',
  },
  leftCards: {
    marginBottom: '10px',
  },
  statusOff: {
    marginBottom: '10px',
    backgroundColor: '#80808029',
  },
  texts: {
    fontSize: '15px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
    color: 'gray',
    whiteSpace: 'pre-line',
  },
  resultImg: {
    width: '50px',
    height: '50px',
    borderRadius: '25px',
    margin: '10px',
    '& :hover': {
      opacity: '0.5',
    },
  },
  resultName: {
    fontSize: '16px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
  },
  resultDate: {
    fontSize: '12px',
    fontFamily: 'Nunito',
    color: 'gray',
  },
  lineBreak: {
    height: '2px',
    borderBottom: '1px solid #808080a1',
    margin: '0 10px 0 10px',
  },
  resultDescription: {
    fontSize: '16px',
    fontFamily: 'Nunito',
    marginBottom: '10px',
  },
  textFiles: {
    fontSize: '14px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
  },
  iconButton: {
    padding: '5px',
  },
  iconLikes: {
    padding: '0px',
  },
  filesResult: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  contentRFiles: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  containerRFiles: {
    width: '250px',
    height: '40px',
    margin: '5px',
    display: 'flex',
    padding: '5px',
    alignItems: 'center',
    borderRadius: '10px',
    justifyContent: 'space-between',
    backgroundColor: '#E4E6EB',
    overflow: 'hidden',
  },
  textRFiles: {
    fontSize: '14px',
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    textOverflow: 'ellipsis',
    width: '213px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  buttonCont: {
    display: 'flex',
  },
}

export const Button = styled.button`
  width: ${(props) => (props.width === 'fullWidth' ? '100%' : '150px')};
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 36px;
  letter-spacing: 1px;
  margin:${(props) => (props.width === 'fullWidth' ? '0' : '0 5px 0 5px')};
  &:hover {
    background-color: #da8d00;
    border-color: #fff;
  }
  &:disabled {
    background-color: grey;
    border-color: #fff;
  }
}
`;

export const useStyles = makeStyles(styles);
